
import { defineComponent, ref, reactive, toRefs, onMounted, watch } from 'vue'
import router from '@/router/index'
import { mapState, mapMutations, mapActions } from 'vuex'
import store from '@/store'
import axsios from 'axios'
import page from '@/views/page.vue'
import { useRoute } from 'vue-router'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default defineComponent({
  setup() {
    // function getFile(cal: any) {
    //   axsios.get('/baseApi/menulist.json').then((res: any) => {
    //     const data = res.data
    //     const arr = data
    //     const _route: any = recursionRoutes(arr)
    //     store.commit('FRESH_MYROUTES', _route)
    //     cal()
    //   })
    // }
    // function recursionRoutes(data: any) {
    //   const arr: any = []
    //   if (data.length) {
    //     data.forEach((item: any) => {
    //       const a = {
    //         name: item.key,
    //         path: item.key,
    //         component: page,
    //         children: recursionRoutes(item.children || []),
    //         meta: {
    //           page: JSON.stringify(item.page)
    //         }
    //       }
    //       arr.push(a)
    //       const _route: any = router.options.routes[1].children
    //       _route.push(a)
    //     })
    //   }
    //   return arr
    // }
    const route: any = useRoute()
    router.beforeEach((to: any, from: any, next) => {
      if (!to.name && to.path.includes('/page')) {
        router.push({
          name: 'Layout',
          query: route.query
        })
      }
      next()
    })
    const simpleImage: any = ref('')
    watch(
      () => route.query,
      (val: any) => {
        const whitepage = ['/stockpool', '/stocknotes/kline', '/askingdetail']
        // const whitepage = hash.indexOf('#/page') < 0 && hash.indexOf('#/askingdetail') < 0 && hash.indexOf('#/stockpool') < 0
        if (val.theme === 'dark' && !whitepage.includes(route.path)) {
          simpleImage.value = require('@/assets/nodata_dark_v.png')
          return
        }
        simpleImage.value = require('@/assets/nodata_light_v.png')
      },
      { deep: true }
    )
    watch(
      () => route,
      (val) => {
        const iscommitInfoPage = ['excellentcourse', 'selectedtopics', 'allcourse', 'specialcourse', 'coursedetail']
        const routeName = route.query.softNameAbbr || 'jfztADV'
        if (iscommitInfoPage.indexOf(route.name) > -1) {
          if (routeName === 'jfztADV') {
            // 擒龙版
            store.commit('setPcqueryInfo', {
              subjectCode: 'jfql.pc',
              appcode: 'com.rjhy.uranus',
              serverid: route.query.serverId || route.query.serverid || '200',
              appversion: route.query.appversion || '3.1.0'
            })
          } else if (routeName === 'jfzt') {
            // 旗舰版
            store.commit('setPcqueryInfo', {
              subjectCode: 'jfqj.pc',
              appcode: 'com.rjhy.superstars',
              serverid: route.query.serverId || route.query.serverid || '200',
              appversion: route.query.appversion || '3.1.0'
            })
          }
        }
      },
      { deep: true }
    )
    return {
      route,
      simpleImage,
      zhCN,
      xp: route.query.os
    }
  }
})
